import { Box } from "@mui/material";
import AcxMainTextField from "components/UI/AcxMainTextField";
import React, { useRef } from "react";
import { DataFormatPatternType } from "../types";
import useHoverAction from "../hooks/useHoverAction";
import DeleteButton from "../components/DeleteButton";
import theme from "Theme/AppTheme";

type DateFormatPatternProps = {
    datePattern: DataFormatPatternType;
    updateDateFormatPattern: (key: string, value: string) => void;
    removeDateFormatPattern: () => void;
};

const DateFormatPattern: React.FC<DateFormatPatternProps> = ({
    datePattern,
    updateDateFormatPattern,
    removeDateFormatPattern,
}) => {
    const { id, pattern } = datePattern;

    const containerRef = useRef<HTMLDivElement>(null);
    const { showAction, handlers } = useHoverAction(containerRef);

    return (
        <Box
            key={id}
            sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                background: theme.palette.white.main,
                padding: 1,
                borderRadius: 2,
            }}
            ref={containerRef}
            {...handlers}
        >
            <AcxMainTextField
                fullWidth
                id={`date-format-pattern-${id}`}
                value={pattern}
                placeholderText="Enter Date Format..."
                onChange={(e) =>
                    updateDateFormatPattern("pattern", e.target.value)
                }
                containerStyle={{ flex: 1 }}
            />
            <DeleteButton
                onDelete={removeDateFormatPattern}
                showDelete={showAction}
            />
        </Box>
    );
};

export default DateFormatPattern;
